
import RequestAbstract from "../abstract";

export default class AccountingCryptoCollections extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/accounting/crypto-collections";
    }
}

